import { render, staticRenderFns } from "./TouchForInstallersPage.vue?vue&type=template&id=5d6567ba&"
import script from "./TouchForInstallersPage.vue?vue&type=script&lang=js&"
export * from "./TouchForInstallersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports